import { isset } from "./default"

export const error_handle = (error) => {
    console.log(error)
    try {
        if (error.response) {
            let log = JSON.stringify(error.response.data.detail)
            if (error.response.status == 401 || error.response.status == 403) {
                window.location.href = `#/login?next=${encodeURI("/")}&error=${log}`
                return
            }
            setTimeout(() => {
                window.alert(log)
            }, 100)
            return
        }
        if (isset(error.result)) {
            if (!error.result) {
                setTimeout(() => {
                    window.alert(error.message)
                }, 100)
                return
            }
        }

    } catch (error2) {
        console.log(error2)
        setTimeout(() => {
            window.alert(error2)
        }, 100)
    }

}